"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeAttemptWaitDuration = void 0;
const baseDurationWait = 10;
function makeAttemptWaitDuration(attemptCount) {
    return Math.min(Math.max(Math.floor(Math.pow(attemptCount + 1, 3) * baseDurationWait), baseDurationWait), 5000);
}
exports.makeAttemptWaitDuration = makeAttemptWaitDuration;
